import BaseCrudService from '@/services/base-crud-service'
import projectConfig from '@/config/project-config'
import axiosHttp from '@/utilities/axios-http'

class ProjectService extends BaseCrudService {
  assignMembers = (id, members) => {
    return axiosHttp.patch(`${this.resourcePath}/${id}/members`, {
      members
    })
  }

  removeMember = (id, user_id) => {
    return axiosHttp.patch(
      `${this.resourcePath}/${id}/members/${user_id}/remove`
    )
  }

  uploadDocument = (id, payload) => {
    return axiosHttp.post(
      `${this.resourcePath}/${id}/documents/upload`,
      payload
    )
  }

  downloadDocument = (id, file_name) => {
    return axiosHttp.get(
      `${this.resourcePath}/${id}/documents/${file_name}/download`,
      {
        responseType: "stream",
      }
    )
  }
}

export default new ProjectService(projectConfig.API_RESOURCE)
